var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { AmplifyConfig } from 'services/auth/AmplifyConfig';
import { Home } from 'pages/Home/Home';
import { RouteLayout } from 'components/Routes/RouteLayout';
import { useAuth } from 'services/auth/AuthProvider';
import { AppLoading } from 'components/Shared/Loading/AppLoading/AppLoading';
import { ThemeProvider } from '@emotion/react';
import { materialTheme } from 'styles/theme/materialTheme';
import { Logout } from 'components/Logout/Logout';
import { EngDataHome } from 'pages/EngDataHome/EngDataHome';
import { ForbiddenPage } from 'pages/ForbiddenPage/Forbidden';
import { ConfirmProvider } from 'material-ui-confirm';
import { EngDataProductPage, engDataProductPageLoader } from 'components/EngData/EngDataProduct/EngDataProductPage';
import { EngDataSearchForm, productSearchFormAction } from 'components/EngData/EngDataSearchForm/EngDataSearchForm';
import { EngDataSearchResults, engDataSearchResultsLoader, } from 'components/EngData/EngDataSearchResults/EngDataSearchResults';
import { productHeaderFormAction } from 'components/EngData/EngDataProduct/EngDataProductHeaderForm/EngDataProductHeaderForm';
import { ProductExpire } from 'components/ProductExpire/ProductExpire';
import { productExpireFormAction, ProductExpireSearchForm, } from 'components/ProductExpire/ProductExpireSearchForm/ProductExpireSearchForm';
import { ProductExpireSearchResults, productExpireSearchResultsLoader, } from 'components/ProductExpire/ProductExpireSearchResults/ProductExpireSearchResults';
import { ProductExpireDetailPage } from 'components/ProductExpire/ProductExpireDetailPage/ProductExpireDetailPage';
import { SearchProductProvider } from 'context/searchProduct/SearchProductProvider';
import { CSPOnDemand } from 'components/CSPOnDemand/CSPOnDemand';
import { ProductHierarchy } from 'components/ProductHierarchy/ProductHierarchy';
import { Catalogs } from 'components/Catalogs/Catalogs';
import { CatalogRun } from 'components/CatalogRun/CatalogRun';
import { CatalogRequests } from 'components/CatalogRequests/CatalogRequests';
import { CatalogRequestAdHoc } from 'components/CatalogRequestAdHoc/CatalogRequestAdHoc';
import { useCheckAuthScope } from 'services/helperFunctions/useCheckAuthScope';
import { CATALOG_SCOPES, CPA_SCOPES, PRICING_SCOPES } from 'utils/constants';
import { CpaHome } from 'pages/CpaHome/CpaHome';
import { CpaSearch } from 'components/Cpa/CpaSearch/CpaSearch';
import { CpaProduct, cpaProductLoader } from 'components/Cpa/CpaProduct/CpaProduct';
import { CpaProductContextProvider } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { ErrorPage } from 'components/Shared/ErrorPage/ErrorPage';
import { ProductBuild } from 'components/ProductBuild/ProductBuild';
import { ProductBuildSearchForm } from 'components/ProductBuild/ProductBuildSearchForm/ProductBuildSearchForm';
import { ProductBuildSearchFormMulti } from 'components/ProductBuild/ProductBuildSearchFormMulti/ProductBuildSearchFormMulti';
import { ProductBuildPage, ProductBuildPageLoader } from 'components/ProductBuild/ProductBuildPage/ProductBuildPage';
import { ProductValidate } from 'components/ProductValidate/ProductValidate';
import { ProductValidateSearchForm } from 'components/ProductValidate/ProductValidateSearchForm/ProductValidateSearchForm';
import { ProductSearch } from 'components/ProductSearch/ProductSearch';
import { ProductInfoPage, ProductInfoPageLoader } from 'components/ProductInfo/ProductInfoPage';
import { SearchProduct } from 'components/AdvancedSearch/SearchProduct';
import { ProductSearchListSearch } from 'components/ProductSearch/ProductSearchListSearch/ProductSearchListSearch';
import { NewSearchOutlet } from 'components/NewSearch/NewSearchOutlet';
import { ProductSearchHierarchy } from 'components/ProductSearch/ProductSearchHierarchy/ProductSearchHierarchy';
import { ParsedProduct } from 'components/ParsedProduct/ParsedProduct';
import { ParsedProductSearchForm } from 'components/ParsedProduct/ParsedProductSearchForm/ParsedProductSearchForm';
import { ParsedProductFormMulti } from 'components/ParsedProduct/ParsedProductMulti/ParsedProductFormMulti';
import { ParsedProductSearchResults } from 'components/ParsedProduct/ParsedProductSearchResults/ParsedProductSearchResults';
import { MatrixExtract } from 'components/MatrixExtract/MatrixExtract';
Amplify.configure(AmplifyConfig);
export var router = createBrowserRouter([
    {
        path: '/',
        element: _jsx(RouteLayout, {}),
        children: [
            {
                path: '/',
                element: _jsx(Home, {}),
            },
            {
                element: _jsx(ProtectedRoute, { authScopes: CPA_SCOPES }),
                children: [
                    {
                        path: '/cpa',
                        element: _jsx(CpaHome, {}),
                        children: [
                            {
                                path: '',
                                element: _jsx(CpaSearch, {}),
                            },
                            {
                                path: 'product',
                                element: _jsx(ErrorPage, { defaultErrorMessage: "Invalid CPA URL", fallbackPath: "/cpa" }),
                            },
                            {
                                path: 'product/:cpn/:stndProdRef/:tab?',
                                element: (_jsx(CpaProductContextProvider, { children: _jsx(CpaProduct, {}) })),
                                loader: cpaProductLoader,
                                errorElement: (_jsx(ErrorPage, { defaultErrorMessage: "UnKnown Custom Add Error", fallbackPath: "/cpa" })),
                            },
                            {
                                path: 'product/:cpn/:tab?',
                                element: (_jsx(CpaProductContextProvider, { children: _jsx(CpaProduct, {}) })),
                                loader: cpaProductLoader,
                                errorElement: (_jsx(ErrorPage, { defaultErrorMessage: "UnKnown Custom Edit Error", fallbackPath: "/cpa" })),
                            },
                        ],
                    },
                ],
            },
            {
                path: '/engdatamaint',
                element: _jsx(EngDataHome, {}),
                children: [
                    {
                        path: 'search',
                        element: (_jsx(ProtectedRouteforPreprod, __assign({ path: "/engdatamaint" }, { children: _jsx(EngDataSearchForm, {}) }))),
                        action: productSearchFormAction,
                        children: [
                            {
                                path: ':searchText',
                                element: _jsx(EngDataSearchResults, {}),
                                loader: engDataSearchResultsLoader,
                            },
                        ],
                    },
                    {
                        path: 'product/:productId',
                        element: _jsx(EngDataProductPage, {}),
                        loader: engDataProductPageLoader,
                        action: productHeaderFormAction,
                        children: [],
                    },
                ],
            },
            {
                path: '/product-build',
                element: _jsx(ProductBuild, {}),
                children: [
                    {
                        path: 'search',
                        element: _jsx(ProductBuildSearchForm, {}),
                    },
                    {
                        path: 'multi',
                        element: _jsx(ProductBuildSearchFormMulti, {}),
                    },
                    {
                        path: 'build',
                        element: _jsx(ProductBuildPage, {}),
                        loader: ProductBuildPageLoader,
                    },
                ],
            },
            {
                path: '/product-validate',
                element: _jsx(ProductValidate, {}),
                children: [
                    { path: 'search', element: _jsx(ProductValidateSearchForm, {}) },
                    {
                        path: 'validate',
                        element: _jsx(ProductBuildPage, {}),
                        loader: ProductBuildPageLoader,
                    },
                ],
            },
            {
                path: '/parsed-product',
                element: _jsx(ParsedProduct, {}),
                children: [
                    {
                        path: 'search',
                        element: _jsx(ParsedProductSearchForm, {}),
                    },
                    {
                        path: 'multi',
                        element: _jsx(ParsedProductFormMulti, {}),
                        children: [
                            {
                                path: ':urlParams',
                                element: _jsx(ParsedProductSearchResults, {}),
                            },
                        ],
                    },
                    {
                        path: 'details',
                        element: _jsx(ProductBuildPage, {}),
                        loader: ProductBuildPageLoader,
                    },
                ],
            },
            {
                path: '/product-info',
                children: [
                    {
                        path: 'info',
                        element: _jsx(ProductInfoPage, {}),
                        loader: ProductInfoPageLoader,
                    },
                ],
            },
            {
                path: '/product-expire',
                element: (_jsx(ProtectedRouteforPreprod, __assign({ path: "/product-expire" }, { children: _jsx(ProductExpire, {}) }))),
                children: [
                    {
                        path: 'search',
                        element: _jsx(ProductExpireSearchForm, {}),
                        action: productExpireFormAction,
                        children: [
                            {
                                path: ':searchText',
                                element: _jsx(ProductExpireSearchResults, {}),
                                loader: productExpireSearchResultsLoader,
                            },
                        ],
                    },
                    {
                        path: ':productId?',
                        element: _jsx(ProductExpireDetailPage, {}),
                    },
                ],
            },
            {
                path: '/403',
                element: _jsx(ForbiddenPage, {}),
            },
            {
                path: '/search',
                element: _jsx(NewSearchOutlet, {}),
                children: [
                    {
                        path: 'simple/product',
                        element: _jsx(ProductSearch, {}),
                    },
                    {
                        path: 'simple/list',
                        element: _jsx(ProductSearchListSearch, {}),
                    },
                    {
                        path: 'advanced',
                        element: (_jsx(SearchProductProvider, { children: _jsx(SearchProduct, {}) })),
                    },
                    {
                        path: 'hierarchy',
                        element: _jsx(ProductSearchHierarchy, {}),
                    },
                ],
            },
            {
                path: '/search/productHierarchy',
                element: _jsx(ProductHierarchy, {}),
            },
            {
                path: '/csp-on-demand',
                element: (_jsx(ProtectedRouteforPreprod, __assign({ path: "/csp-on-demand" }, { children: _jsx(CSPOnDemand, {}) }))),
            },
            {
                path: '/catalogs',
                element: _jsx(Catalogs, {}),
            },
            {
                element: _jsx(ProtectedRoute, { authScopes: CATALOG_SCOPES }),
                children: [
                    {
                        path: '/catalogs/run',
                        element: _jsx(CatalogRun, {}),
                    },
                    {
                        path: '/catalogs/adhoc',
                        element: _jsx(CatalogRequestAdHoc, {}),
                    },
                ],
            },
            {
                path: '/catalogs/requests',
                element: _jsx(CatalogRequests, {}),
            },
            {
                element: _jsx(ProtectedRoute, { authScopes: PRICING_SCOPES }),
                children: [
                    {
                        path: '/matrix-extract',
                        element: _jsx(MatrixExtract, {}),
                    },
                ],
            },
            {
                path: '/logout',
                element: _jsx(Logout, {}),
            },
        ],
    },
]);
export function ProtectedRoute(_a) {
    var authScopes = _a.authScopes;
    var isAuthed = useCheckAuthScope(authScopes);
    if (!isAuthed) {
        return _jsx(Navigate, { to: "/", state: { accessDenied: true } });
    }
    return _jsx(Outlet, {});
}
export function ProtectedRouteforPreprod(_a) {
    var path = _a.path, children = _a.children;
    var isEnvAllowed = useCheckEnvScope(path);
    if (!isEnvAllowed) {
        return (_jsx(ErrorPage, { defaultErrorMessage: "This page is not available in the current environment.", fallbackPath: "/" }));
    }
    return children;
}
export function useCheckEnvScope(path) {
    var ENV_SCOPES = {
        PRE_PROD_DISABLED: ['/product-expire', '/csp-on-demand', '/engdatamaint'],
    };
    var isPreProd = process.env.REACT_APP_ENV_NAME === 'preprod';
    if (isPreProd && ENV_SCOPES.PRE_PROD_DISABLED.includes(path)) {
        return false;
    }
    return true;
}
export function App() {
    var auth = useAuth();
    return (_jsx(ThemeProvider, __assign({ theme: materialTheme }, { children: _jsx(ConfirmProvider, { children: auth.isAuthenticated ? (_jsx(RouterProvider, { router: router, fallbackElement: _jsx(AppLoading, {}) })) : (_jsx(AppLoading, {})) }) })));
}
